import {Badge} from '@dropbox/dig-components/badge';
import {Box} from '@dropbox/dig-foundations';

/** An alert count: Audit's needs-attention, the updates you owe. */
export const AlertCountBadge = ({count, label}: {count: number; label?: string}) => (
  <Badge tone="alert" size="xsmall" aria-label={label}>
    {count}
  </Badge>
);

/**
 * A rail row's alert count, centered in the same 24px slot as the rows' small
 * icon buttons, so it lines up with the link icons and chevrons above and below.
 */
export const RailBadge = (props: {count: number; label?: string}) => (
  <Box display="flex" justifyContent="center" style={{width: 24, flexShrink: 0}}>
    <AlertCountBadge {...props} />
  </Box>
);
